module.exports = __webpack_public_path__ + "img/profil-parfait.dd2f1ddb.png";